var map = {
	"./EVSEs.svg": "f1f1",
	"./adminAccount.svg": "1238",
	"./chargingPoint.svg": "e5db",
	"./chargingSession.svg": "4aff",
	"./dashboard.svg": "f782",
	"./faultDiagnosis.svg": "2deb",
	"./location.svg": "1c50",
	"./peoples.svg": "2f11",
	"./rise.svg": "6c8e",
	"./tariffGroups.svg": "0993",
	"./tariffs.svg": "8728",
	"./transactions.svg": "a305",
	"./user.svg": "b3b5",
	"./users.svg": "5055"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";